/*=========================================================================================
  File Name: moduleMessagerie.js
  Description: Messagerie Module
==========================================================================================*/

import state from './moduleMessagerieState.js';
import mutations from './moduleMessagerieMutations.js';
import actions from './moduleMessagerieActions.js';
import getters from './moduleMessagerieGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
